import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import { useDispatch } from 'react-redux'
import { changeRoute } from '../../store/slices/SessionSlice'
import BlockIcon from '@mui/icons-material/Block'

const Unauthorized = () => {
    const dispatch = useDispatch()

    return (
        <Stack
            height='80vh'
            spacing={2}
            textAlign='center'
            justifyContent='center'
            alignItems='center'>
            <Stack spacing={2} direction='row'>

                <Typography variant='h4' fontWeight={600}>
                    Access denied
                </Typography>
                <BlockIcon fontSize='large' color='error' />

            </Stack>
            <Typography variant='h4' fontWeight={600}>
                You don&apos;t have permission to access this page.
            </Typography>
            <Button
                variant='contained'
                onClick={() => dispatch(changeRoute({ route: 'overview' }))}>
                Go to Home
            </Button>
        </Stack>

    )
}

export default Unauthorized
